import { FC } from "react";
import { LoaderProps } from "./types";
import { StyledWalker, StyledWalkerBackground, StyledWrapper } from "./styles";

const Loader: FC<LoaderProps> = ({ isLoading, position }) => {
  return isLoading ? (
    <StyledWrapper position={position}>
      <StyledWalkerBackground >
        <StyledWalker/>
      </StyledWalkerBackground >
    </StyledWrapper>
  ) : null;
};

export default Loader;
